import { Typography } from "@mui/material";
import { useStyle } from "./style";
import { useTranslation } from "react-i18next";

interface IParams {
    handleChangeAddress(): void;
}

export const ChangeAddressLink = (props: IParams) => {
    const { handleChangeAddress } = props;

    const { classes } = useStyle();
    const { t } = useTranslation("home");

    return (
        <Typography
            className={classes.changeAddressLink}
            color="primary"
            variant="normal"
            onClick={handleChangeAddress}
        >
            {t("changeAddress")}
        </Typography>
    );
};
